import { ProductShipment } from '@app/models/product-shipment';
import { Action } from '@ngrx/store';

export enum ProductShipmentActionTypes {
  LoadByFollow = '[API] Load product shipments by follow',
  LoadByFollowSuccess = '[API] Load product shipments by follow success',
  LoadByFollowFail = '[API] Load product shipments by follow fail',

  LoadByProduct = '[API] Load product shipments by product',
  LoadByProductSuccess = '[API] Load product shipments by product success',
  LoadByProductFail = '[API] Load product shipments by product fail',

  LoadByCountryDepartment = '[API] Load product shipments by Country Department',
  LoadByCountryDepartmentSuccess = '[API] Load product shipments by Country Department success',
  LoadByCountryDepartmentFail = '[API] Load product shipments by Country Department fail',

  LoadByProductMirror = '[ProductCountryShipmentMirror] Load Product country shipment mirror',
  LoadByProductMirrorSuccess = '[ProductCountryShipmentMirror] Load Product country shipment mirror success',
  LoadByProductMirrorFail = '[ProductCountryShipmentMirror] Load Product country shipment mirror fail',

  AddOne = '[ProductShipment] Add one',
  AddAll = '[ProductShipment] Add all',
  UpsertMany = '[ProductShipment] Upser many',
  BulkUpdate = '[API] Bulk update product shipment',
  BulkUpdateSuccess = '[API] Bulk update product shipment success',
  BulkUpdateFail = '[API] Bulk update product shipment fail',
  BulkTransfer = '[API] Bulk transfer product shipment',
  BulkTransferSuccess = '[API] Bulk transfer product shipment success',
  BulkTransferFail = '[API] Bulk transfer product shipment fail',

  BulkTransferProforma = '[API] Bulk transfer product proforma',
  BulkTransferProformaSuccess = '[API] Bulk transfer product proforma success',
  BulkTransferProformaFail = '[API] Bulk transfer product proforma fail',

  VoidAction = '[VOID] Void action that should not be handled',
  Clear = '[Clear] Clear product shipment',

  BulkUpdateWeb = '[API] Bulk update web product shipment',
  BulkUpdateWebSuccess = '[API] Bulk update web product shipment success',
  BulkUpdateWebFail = '[API] Bulk update web product shipment fail',
}

export class LoadByFollow implements Action {
  readonly type = ProductShipmentActionTypes.LoadByFollow;
  constructor(
    public FollowId: number,
    public CountryId?: number,
    public ProformaId?: number,
    public ProductId?: number
  ) {}
}

export class LoadByFollowSuccess implements Action {
  readonly type = ProductShipmentActionTypes.LoadByFollowSuccess;
  constructor(public shipments: ProductShipment[]) {}
}

export class LoadByFollowFail implements Action {
  readonly type = ProductShipmentActionTypes.LoadByFollowFail;
  constructor(public error: any) {}
}

export class LoadByProduct implements Action {
  readonly type = ProductShipmentActionTypes.LoadByProduct;
  constructor(public ProductId: number) {}
}

export class LoadByProductSuccess implements Action {
  readonly type = ProductShipmentActionTypes.LoadByProductSuccess;
  constructor(public shipments: ProductShipment[]) {}
}

export class LoadByProductFail implements Action {
  readonly type = ProductShipmentActionTypes.LoadByProductFail;
  constructor(public error: any) {}
}

export class LoadByCountryDepartment implements Action {
  readonly type = ProductShipmentActionTypes.LoadByCountryDepartment;
  constructor(
    public FollowId: number,
    public CountryDepartmentId: any,
    public CountryId: number,
    public businessUnit?: any,
    public typeHierarchy?: any,
    public DestinationCenterId?: any
  ) {}
}

export class LoadByCountryDepartmentSuccess implements Action {
  readonly type = ProductShipmentActionTypes.LoadByCountryDepartmentSuccess;
  constructor(public shipments: ProductShipment[]) {}
}

export class LoadByCountryDepartmentFail implements Action {
  readonly type = ProductShipmentActionTypes.LoadByCountryDepartmentFail;
  constructor(public error: any) {}
}

export class BulkUpdate implements Action {
  readonly type = ProductShipmentActionTypes.BulkUpdate;
  constructor(public data: any, public dataLoad?: any) {}
}

export class BulkUpdateSuccess implements Action {
  readonly type = ProductShipmentActionTypes.BulkUpdateSuccess;
  constructor(public shipments: ProductShipment[], public dataLoad?: any) {}
}

export class BulkUpdateFail implements Action {
  readonly type = ProductShipmentActionTypes.BulkUpdateFail;
  constructor(public error: any) {}
}

export class BulkUpdateWeb implements Action {
  readonly type = ProductShipmentActionTypes.BulkUpdateWeb;
  constructor(public data: any, public dataLoad?: any) {}
}

export class BulkUpdateWebSuccess implements Action {
  readonly type = ProductShipmentActionTypes.BulkUpdateWebSuccess;
  constructor(public shipments: ProductShipment[], public dataLoad?: any) {}
}

export class BulkUpdateWebFail implements Action {
  readonly type = ProductShipmentActionTypes.BulkUpdateWebFail;
  constructor(public error: any) {}
}

export class BulkTransfer implements Action {
  readonly type = ProductShipmentActionTypes.BulkTransfer;
  constructor(public data: any) {}
}

export class BulkTransferSuccess implements Action {
  readonly type = ProductShipmentActionTypes.BulkTransferSuccess;
  constructor(public shipments: ProductShipment[]) {}
}

export class BulkTransferFail implements Action {
  readonly type = ProductShipmentActionTypes.BulkTransferFail;
  constructor(public error: any) {}
}

export class BulkTransferProforma implements Action {
  readonly type = ProductShipmentActionTypes.BulkTransferProforma;
  constructor(public data: any) {}
}

export class BulkTransferProformaSuccess implements Action {
  readonly type = ProductShipmentActionTypes.BulkTransferProformaSuccess;
  constructor(public productShipments: ProductShipment[]) {}
}

export class BulkTransferProformaFail implements Action {
  readonly type = ProductShipmentActionTypes.BulkTransferProformaFail;
  constructor(public error: any) {}
}

export class VoidAction implements Action {
  readonly type = ProductShipmentActionTypes.VoidAction;
  constructor() {}
}

export class UpsertMany implements Action {
  readonly type = ProductShipmentActionTypes.UpsertMany;
  constructor(public productShipments: ProductShipment[]) {}
}

export class LoadByProductMirror implements Action {
  readonly type = ProductShipmentActionTypes.LoadByProductMirror;
  constructor(public ProductId: number) {}
}

export class LoadByProductMirrorSuccess implements Action {
  readonly type = ProductShipmentActionTypes.LoadByProductMirrorSuccess;
  constructor(public shipments: ProductShipment[]) {}
}

export class LoadByProductMirrorFail implements Action {
  readonly type = ProductShipmentActionTypes.LoadByProductMirrorFail;
  constructor(public error: any) {}
}

export class Clear implements Action {
  readonly type = ProductShipmentActionTypes.Clear;
  constructor() {}
}

export type ProductShipmentActionsUnion =
  | LoadByFollow
  | LoadByFollowSuccess
  | LoadByFollowFail
  | LoadByProduct
  | LoadByProductSuccess
  | LoadByProductFail
  | LoadByCountryDepartment
  | LoadByCountryDepartmentSuccess
  | LoadByCountryDepartmentFail
  | BulkTransfer
  | BulkTransferSuccess
  | BulkTransferFail
  | BulkUpdate
  | BulkUpdateSuccess
  | BulkUpdateFail
  | BulkTransferProforma
  | BulkTransferProformaSuccess
  | BulkTransferProformaFail
  | VoidAction
  | UpsertMany
  | LoadByProductMirror
  | LoadByProductMirrorSuccess
  | LoadByProductMirrorFail
  | Clear
  | BulkUpdateWeb
  | BulkUpdateWebSuccess
  | BulkUpdateWebFail;
